import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { Footer } from "../../shared/footer/footer";
import { AlwaysThere } from "../../shared/always-there/always-there";
import { InterestYou } from "../../shared/interest-you/interest-you";
import { Navbar } from "../../shared/navbar/navbar";
import { SmallFaq } from "../../shared/small-faq/small-faq";
import { Inject, PLATFORM_ID } from '@angular/core';
@Component({
  selector: 'app-review',
  standalone: true,
  imports: [CommonModule, SmallFaq, Footer, Navbar, AlwaysThere, InterestYou],
  templateUrl: './review.html',
  styleUrl: './review.css',
})
export class Review implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}
  // Les 6 avis (les 3 premiers tirés de ton image)
  reviews = [
    {
      name: 'Angélique',
      avatar: 'assets/img/Ellipse14.svg',
      stars: 4,
      paragraphs: [
        "J'ai souscrit il y a quelques jours à un forfait sans engagement sur le réseau Orange, et je suis pleinement satisfaite. Le réseau est fluide, sans latence, et la qualité est au rendez-vous.",
        "Le service client est également au top : réactif, professionnel et à l'écoute. Je recommande sans hésitation."
      ]
    },
    {
      name: 'Sylvie',
      avatar: 'assets/img/Ellipse15.svg',
      stars: 5,
      paragraphs: [
        "Récemment devenue cliente chez YouPrice, je suis agréablement surprise par la qualité du service et la rapidité avec laquelle les équipes résolvent les éventuels soucis.",
        "Un grand merci à toute l'équipe pour son professionnalisme et ses compétences.",
        "Je recommande vivement YouPrice."
      ]
    },
    {
      name: 'Jade',
      avatar: 'assets/img/Ellipse16.svg',
      stars: 5,
      paragraphs: [
        "Une très belle expérience avec YouPrice. Au-delà des prix compétitifs, j'ai particulièrement apprécié l'accueil et la disponibilité des conseillers : attentifs, bienveillants et efficaces pour trouver la meilleure solution.",
        "Un grand merci à toute l'équipe !"
      ]
    },
    {
      name: 'Ayan',
      avatar: 'assets/img/Ellipse17.svg', /* Pense à mettre le bon chemin vers l'image */
      stars: 4,
      paragraphs: [
        "Un service client réactif, professionnel et à l'écoute.",
        "La qualité du réseau est au rendez-vous et correspond parfaitement à mes attentes.",
        "Merci pour votre efficacité !"
      ]
    },
    {
      name: 'Djamel',
      avatar: 'assets/img/Ellipse18.svg', /* Pense à mettre le bon chemin vers l'image */
      stars: 4,
      paragraphs: [
        "Très bonne qualité de service sur le réseau SFR pour ma part.",
        "L'activation a été effectuée rapidement et presque sans manipulation de ma part.",
        "Le service client est réactif et efficace pour résoudre les éventuels problèmes techniques, avec un excellent suivi.",
        "Très professionnel, je recommande."
      ]
    },
    {
      name: 'Thibault',
      avatar: 'assets/img/Ellipse19.svg', /* Pense à mettre le bon chemin vers l'image */
      stars: 5,
      paragraphs: [
        "Excellent service client ! Une équipe très réactive, professionnelle et à l'écoute.",
        "Ma portabilité sur le réseau Bouygues Telecom s'est effectuée sans encombre et dans les délais annoncés.",
        "Je suis pleinement satisfait de mon forfait et recommande sans hésitation."
      ]
    }
  ];

  currentPage = 0;
  itemsPerPage = 3;
  gap = 34; // Espace entre les cartes en pixels
  
  // Variables pour le swipe mobile
  touchStartX = 0;
  touchEndX = 0;

  ngOnInit() {
     this.updateItemsPerPage();
  }

  // Écoute les changements de taille d'écran pour adapter l'affichage
@HostListener('window:resize')
  onResize() {
    this.updateItemsPerPage();
  }

  updateItemsPerPage() {
    // 1 carte sur mobile, 3 sur Desktop
    this.itemsPerPage = window.innerWidth <= 768 ? 1 : 3;
    
    // Sécurité pour ne pas dépasser si on redimensionne l'écran
    if (this.currentPage >= this.totalPages) {
      this.currentPage = Math.max(0, this.totalPages - 1);
    }
  }

  get totalPages(): number {
    return Math.ceil(this.reviews.length / this.itemsPerPage);
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i);
  }

  goToPage(page: number) {
    this.currentPage = page;
  }

  // Calcul du déplacement CSS (translation)
  getTransform() {
    const moveRatio = this.currentPage * 100;
    const gapOffset = this.currentPage * this.gap;
    return `translateX(calc(-${moveRatio}% - ${gapOffset}px))`;
  }

  // Largeur dynamique des cartes selon l'écran
  getCardFlex() {
    if (this.itemsPerPage === 1) {
       return '0 0 100%';
    }
    return `0 0 calc((100% - ${this.gap * (this.itemsPerPage - 1)}px) / ${this.itemsPerPage})`;
  }

  // Logique du Swipe (Tactile sur mobile)
  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
  }

  handleSwipe() {
    const swipeDistance = this.touchStartX - this.touchEndX;
    if (swipeDistance > 50 && this.currentPage < this.totalPages - 1) {
       this.currentPage++; // Swipe gauche (suivant)
    } else if (swipeDistance < -50 && this.currentPage > 0) {
       this.currentPage--; // Swipe droit (précédent)
    }
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      // On attend que le navigateur soit totalement "libre"
      setTimeout(() => {
        this.updateItemsPerPage();
      }, 200); 
    }
  }

  
}